import '../sass/app.scss';
import EligibleDialog from './common/EligibleDialog';

import Navbar from './navbar';

if (!window.location.pathname.match(/^\/kiosk\//)) {
    new Navbar(pageOptions);
}
EligibleDialog(pageOptions.userId);
